import { useRouter } from 'next/router';

export function useLkBasePath(): string {
  const { locale } = useRouter();

  return `/lk/${locale}`;
}
